import { type ActionItem } from 'shared/ui'
import type { TaggedContactsRow } from 'entities/Tags/model/TaggedContactsRow'
import { type TaggedContactsStore } from 'pages/settings/pages/tags/store/TaggedContactsStore'

export const getTaggedContactsTableActions = (
  item: TaggedContactsRow,
  TaggedContactsStore: TaggedContactsStore,
  isUserCanManageTags: boolean
): ActionItem[] => {
  return [
    {
      icon: 'edit',
      text: 'Edit',
      onAction: () => TaggedContactsStore.onShowDetails(item.id),
    },
    {
      icon: 'tagRemove',
      text: 'Remove tag',
      buttonProps: {
        disabled: !isUserCanManageTags,
      },
      onAction: () => TaggedContactsStore.onContactTagRemove(item.id),
    },
  ]
}
